<template>
  <div class="status" :class="`status-${statusID}`">
    {{ statusName }}
  </div>
</template>

<script>
export default {
  props: ["statusID", "statusName"],
};
</script>
